import requestAxios from '@/utils/request'

export function getListImportEventApi (params) {
  return requestAxios.get('enter-score/import-event', {params})
}

export function uploadBackupApi (data) {
  return requestAxios.post('enter-score/upload-backup', data, { headers: {
    'Content-Type': 'multipart/form-data'
  }})
}



// WEBPACK FOOTER //
// ./src/api/enter-score/import.js